import React from 'react';
import { Instagram, Linkedin, Youtube } from 'lucide-react';
import { FaTiktok } from 'react-icons/fa';
import { useLocation, useNavigate } from 'react-router-dom';
import { socialLinks } from '../data/mock';
import { trackCtaClick } from '../utils/analytics';

const Footer = () => {
  const currentYear = new Date().getFullYear();
  const location = useLocation();
  const navigate = useNavigate();

  const socials = [
    { name: 'Instagram', icon: Instagram, url: socialLinks.instagram, cta: 'instagram' },
    { name: 'LinkedIn', icon: Linkedin, url: socialLinks.linkedin, cta: 'linkedin' },
    { name: 'YouTube', icon: Youtube, url: socialLinks.youtube, cta: 'youtube' },
    { name: 'TikTok', icon: FaTiktok, url: socialLinks.tiktok, cta: 'tiktok' }
  ];

  const scrollToSection = (id) => {
    if (location.pathname !== '/') {
      navigate(`/#${id}`);
      return;
    }

    const element = document.getElementById(id);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <footer className="footer">
      <div className="container-custom">
        <div className="footer-content">
          <div className="footer-section">
            <div className="footer-logo">TC</div>
            <p className="footer-tagline">
              Tecnologia, inovação e soluções digitais
            </p>
          </div>

          <div className="footer-section">
            <h4 className="footer-title">Navegação</h4>
            <nav className="footer-nav">
              <button onClick={() => scrollToSection('sobre')} className="footer-link">Sobre</button>
              <button onClick={() => scrollToSection('servicos')} className="footer-link">Serviços</button>
              <button onClick={() => scrollToSection('casos')} className="footer-link">Casos</button>
              <button onClick={() => scrollToSection('contato')} className="footer-link">Contato</button>
              <a href="/faq" className="footer-link">FAQ</a>
              <a href="/sobre" className="footer-link">Sobre (detalhes)</a>
              <a href="/links" className="footer-link">Links oficiais</a>
            </nav>
          </div>

          <div className="footer-section">
            <h4 className="footer-title">Redes sociais</h4>
            <div className="footer-social">
              {socials.map((social) => {
                const IconComponent = social.icon;
                return (
                  <a
                    key={social.name}
                    href={social.url}
                    onClick={() => trackCtaClick({ cta: social.cta, location: 'footer', url: social.url })}
                    target="_blank"
                    rel="noopener noreferrer"
                    className="footer-social-link"
                    aria-label={social.name}
                  >
                    <IconComponent size={20} />
                  </a>
                );
              })}
            </div>
          </div>
        </div>

        <div className="footer-bottom">
          <p className="footer-copyright">
            © {currentYear} Tiago Cardoso. Todos os direitos reservados.
          </p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
